import type { FC } from "react";
import { Navigate, useParams } from "react-router-dom";
import { InspirationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { EarlyFreedomInspirationPage } from "web_myplann/Inspiration/EarlyFreedom/Pages/EarlyFreedomInspirationPage";
import { OwnHomeInspirationPage } from "web_myplann/Inspiration/OwnHome/Pages/OwnHomeInspirationPage";
import { RetirementInspirationPage } from "web_myplann/Inspiration/Retirement/Pages/RetirementInspirationPage";
import { isEnumValue } from "web_myplann/Shared/Utils/parsers";

const PAGES: Record<InspirationTypeEnum, FC> = {
	[InspirationTypeEnum.OwnHome]: OwnHomeInspirationPage,
	[InspirationTypeEnum.EarlyFreedom]: EarlyFreedomInspirationPage,
	[InspirationTypeEnum.Retirement]: RetirementInspirationPage,
};

export const InspirationDetailPage: FC = () => {
	const { id } = useParams();
	const Page = isEnumValue(InspirationTypeEnum, id) ? PAGES[id] : undefined;

	if (!Page) return <Navigate to={Routing.Dashboard.path()} replace />;
	return <Page />;
};
